import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding-bottom: 120px;
  padding-top: 40px;
  margin-top: 40px;

  @media (min-width: 600px) {
    padding-bottom: 0px;
  }
`;

export const FooterContainer = styled.div`
  width: 100%;
  min-height: 286px;
  background-color: #ffffff;
  width: 100%;
  min-height: 286px;
  background: transparent;
  min-height: 286px;
  width: 100%;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr;
  padding: 40px 16px 16px;
  gap: 24px;

  @media (min-width: 500px) {
    grid-template-columns: 1fr 2fr;
  }
  @media (min-width: 1100px) {
    max-width: 992px;
  }
  @media (min-width: 1200px) {
    max-width: 1440px;
  }
`;

export const BrandSection = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  gap: 24px;

  p {
    font-size: 12px;
    color: #6c757d;
  }
`;

export const SocialBox = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 16px;
  margin: 0;
  justify-content: flex-start;
  padding: 0;
`;

export const SocialButton = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background: #f0f0f0;
  color: #6c757d;

  a {
    display: flex;
    align-items: center;
  }
`;
export const LinksSection = styled(BrandSection)`
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;

  @media (min-width: 500px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const LinksList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  list-style: none;
  font-size: 16px;
  gap: 16px;
  padding: 0;
  margin: 0;
`;
export const ItemList = styled.li`
  color: #6c757d;
`;

export const ItemName = styled.div``;